import { Directive, EventEmitter, Type } from "@angular/core";
import { Observable } from "rxjs";

import { BaseDefaultOptionLayouts } from "./base-default-option-layouts.component";
import { OptionsSource } from "./options-source";

@Directive()
export abstract class BaseOptionsDirective<
  Model,
  Identifier extends number | string
> {
  abstract defaultOptionLayoutsComponent: Type<BaseDefaultOptionLayouts<Model>>;

  // defined by directive
  abstract optionsSource: OptionsSource<Model>;
  optionsSourceChange: EventEmitter<OptionsSource<Model>> = new EventEmitter<
    OptionsSource<Model>
  >();

  // defined by directive
  abstract getModelsFromIdentifiers(
    identifiers: Identifier[]
  ): Observable<Model[]>;
  abstract getIdentifierFromModel(model: Model): Identifier;

  queryToModel?(query: string): Model;
}
